// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"ap","shareText":"aq","show":"ar"};